import {useEffect, useRef, useState} from "react";
import {t} from "i18next";
import {Popover, Select} from "antd";
import ApiService from "../../core/service/ApiService";
import {useModal} from "../../core/context/ModalContext";
import StateDescriptionForm from "./StateDescriptionForm";

export default function StateChanger({appointmentId, checkIn, selectedStateId, onStateChange, onStates})
{
    const {openModal, closeModal} = useModal()
    const [states, setStates] = useState([]);
    const [descList, setDescList] = useState([]);
    const [groupDescList, setGroupDescList] = useState([]);
    const [id, setId] = useState(selectedStateId)
    const oldId = useRef(selectedStateId)

    const getStates = async () => {
        if(appointmentId)
        {
            const res = await ApiService.State.GetStateListByCheckin(checkIn ? 1 : 0);
            if(res.success)
            {
                setStates(res.data)
                onStates && onStates(res.data)
            }
        }
    }

    const getStateDescList = async () => {
        const res = await ApiService.State.GetStateGroupDescList();
        if(res.data) {
            setDescList(res.data)
        }
    }

    useEffect(() => {
        getStates();
    }, [checkIn])

    useEffect(() => {
        setId(selectedStateId);
    }, [selectedStateId]);

    useEffect(() => {
        getStateDescList()
    }, []);

    const onChange = async (stateId) => {
        const state = states.find(x => x.id === stateId)
        const _descList = descList.filter(x => x.stateGroupId === state?.stateGroup?.id)
        oldId.current = id
        if(_descList.length > 0) {
            setGroupDescList(_descList)
            setId(stateId)
        }
        else {
            onStateChange && onStateChange(stateId, null);
        }
    }

    return (
        <Popover
            content={
                <StateDescriptionForm
                    descList={groupDescList}
                    onCancel={() => {
                        setId(oldId.current)
                        setGroupDescList([])
                    }}
                    onOk={(descForm) => {
                        onStateChange && onStateChange(id, descForm);
                        setGroupDescList([])
                        closeModal()
                    }}
                />
            }
            open={groupDescList?.length > 0}
        >
            <Select
                placeholder={t('State')}
                value={id}
                style={{width: 200}}
                onChange={onChange}
            >
                <Select.OptGroup label={checkIn ? t('After Check-in') : t('Before Check-in')}>
                    {states.map(x => {
                        return (
                            <Select.Option value={x.id} key={x.id}>
                                <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                                    <div style={{width: 16, height: 16, backgroundColor: x.color, border: '1px solid black'}} />
                                    {x.name}
                                </div>
                            </Select.Option>
                        )
                    })}
                </Select.OptGroup>
            </Select>
        </Popover>
    )
}